import Button from "src/components/button/Button";
import FlyoutPanel from "src/components/flyoutpanel/FlyoutPanel";
import FlagSvg from "src/components/svg/FlagSvg";
import theme from "src/components/themes/DefaultTheme";
import IMovieReview from "src/lib/filmwebid/IMovieReview";
import useReviewReport from "src/lib/filmwebid/useReviewReport";
import styled, { css } from 'src/lib/styles/css';
import { useState } from "react";

//#region [Props]
type ReviewMenuProps = {
	review: IMovieReview;
	className?: string;
	isReported: boolean;
};
//#endregion

//#region [Component]
export default function ReviewMenu({ review, className, isReported }: ReviewMenuProps) {
	const [isOpen, setIsOpen] = useState(false);
	const [doReport, isReporting, isReportingDone] = useReviewReport(review.userId, review.reviewId);

	return (
		<div className={className}>
			<SMenuButton
				disabled={isReporting || isReported}
				onClick={() => setIsOpen(!isOpen)}
				title={isReported ? 'Du har allerede rapportert denne anmeldelsen' : undefined}>
				<SReportedFlag $isReported={isReported} selected={isReported} />
			</SMenuButton>
			{isOpen && <FlyoutPanel onAfterCloseComplete={() => setIsOpen(false)} isClosed={!isReporting && isReportingDone}>
				<SFullWitdthButton onClick={doReport} icon={<FlagSvg />} disabled={isReporting} text="Rapporter anmeldelsen" isOutline />
				<SDescriptionText>Innrapporterte tekster vil bli vurdert av Filmwebs redaksjon for å se om de bryter med våre retningslinjer.</SDescriptionText>
			</FlyoutPanel>}
		</div>
	);
}
//#endregion

//#region [Styles]
const SMenuButton = styled.button`
	background: none;
	border: none;
	padding: 0;
	margin: 0;

	&:not(:disabled) {
		cursor: pointer;
	}
`;

type SReportedFlag = {
	$isReported: boolean;
}

const SReportedFlag = styled(FlagSvg) <SReportedFlag>`
	display: block;
	path {
		${props => props.$isReported ? css`
			fill: ${theme.palette.oransje};
		`: null}

	}
`;

const SFullWitdthButton = styled(Button)`
	width: 100%;
	justify-content: center;
`;

const SDescriptionText = styled.p`
	font-size: ${theme.fonts.tittelXXXS.size};
`;

//#endregion